/* ME.LOL — capture popup + Save-Image in-app fix + in-app escape hatch.
   ==================================================================================
   BUILD 2026-08-20a   ← bump this line EVERY change. Read it live via window.__melolCWV
                          (in the console on me.lol) to confirm the theme matches this file.
   Changelog:
      2026-08-20a  ADD-TO-CART capture trigger (TRIGGER 4). 97.4% of signups happened before the
                  visitor had a cart (11 of 418 had one), so abandoned-cart email had ~14 people/mo
                  to send to against ~365 abandoned carts. Matched on name="add" or literal
                  "add to cart"/"add to bag" — NOT a bare /add/ test, which fires on the
                  'Add The "Finger"' variant label. Click delegation, not a fetch patch (V600
                  already patches fetch/XHR and is the Jul 5 checkout-break suspect).
                  Also: FIRST_VISIT_DELAY_MS 9000 -> 5000; median session is ~23s total / 14s
                  active, so the 9s offer was firing in the last third of the visit.
     2026-07-24f  Retired-domain kill-switch: on a product page whose domain is '*'-marked (expired),
                  block the buy (reuses MELOL_GATED + hides the buy controls) and show a "This one's
                  retired" message. Exposes window.__melolExpired(domain) so search can suppress the
                  "put it on a shirt anyway" offer for retired ones too (optional theme one-liner).
     2026-07-24e  Catalog URL is now cache-busted (10-min bucket) so edits to catalog326.txt go live
                  without a code change — fixes the stale ?v= that hid the '*' denylist marks.
     2026-07-24d  Keep-your-place: the strip's shuffle is now stable per session (seed), and it
                  saves/restores horizontal scroll position across the page reload a card-tap causes —
                  so tapping a shirt no longer dumps you back at the start of the strip.
     2026-07-24c  Catalog denylist marker: the endless strip now hides any catalog entry that doesn't
                  start with a letter/digit — so prefixing a domain with '*' in catalog326.txt hides it
                  (expired domains). Remove the '*' to bring it back on renewal.
     2026-07-24b  Endless Featured strip: lazy-loads the next batch of shirts from the catalog when
                  the user scrolls to the end of #melolFSrow (nothing preloaded; 15 at a time; caps
                  with a "Type your own" card that opens search). Exposes window.__melolCES.
     2026-07-24a  Signup ENRICHMENT: on submit, also captures cart-at-signup (domains/count/value),
                  recent shirts viewed, current design style, device, entry referrer/utm, and the
                  specific drop domain for Notify-Me. Sent to the worker /subscribe. Also: Android-only
                  escape bar, browser-neutral copy ("Open in browser"), regex-crash fix, Save-Image V2.
   ==================================================================================
   Lives in the theme as assets/melol-capture-webview.js, loaded from theme.liquid with one
   <script src ... defer> tag. Pulled OUT of theme.liquid so the template stays under Shopify's
   256 KB limit. Pure ES5, self-contained: injects its own CSS, guards against double-init, and
   does NOT depend on theme internals. Three independent pieces:
     1) email-for-discount capture popup (the former inline "V656" block) + signup enrichment,
     2) Save-Image fix V2 for Facebook/Instagram/Messenger in-app browsers,
     3) in-app-browser escape hatch (Android-only; recovers/escapes blank + frozen pages). */
window.__melolCWV='2026-08-20a';

(function(){ if(window.__melolCWVCss) return; window.__melolCWVCss=1;
  var css="\n#melolSaveImg{position:fixed;inset:0;z-index:100050;background:rgba(0,0,0,.9);display:none;flex-direction:column;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;-webkit-user-select:none;user-select:none;}\n#melolSaveImg.open{display:flex;}\n#melolSaveImg .msi-hint{color:#fff;font:600 14.5px/1.5 -apple-system,Inter,Arial,sans-serif;text-align:center;margin:0 0 12px;max-width:430px;}\n#melolSaveImg .msi-pic{max-width:100%;max-height:56vh;border-radius:14px;box-shadow:0 12px 44px rgba(0,0,0,.55);\n  -webkit-touch-callout:default!important;touch-callout:default;-webkit-user-select:auto;user-select:auto;pointer-events:auto;}\n#melolSaveImg .msi-share{margin:16px 0 0;padding:15px 28px;background:#0a66ff;color:#fff;border:none;border-radius:12px;font:800 16px Inter,Arial,sans-serif;cursor:pointer;min-width:230px;}\n#melolSaveImg .msi-browser{display:none;margin:11px 0 0;padding:13px 22px;background:#16a34a;color:#fff;border:none;border-radius:12px;font:800 15px Inter,Arial,sans-serif;cursor:pointer;min-width:230px;}\n#melolSaveImg .msi-close{margin:13px 0 0;background:none;border:none;color:#bbb;font:600 13px Inter,Arial,sans-serif;text-decoration:underline;cursor:pointer;}\n#melolEC{position:fixed;inset:0;z-index:100020;background:rgba(0,0,0,.62);display:none;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;}\n#melolEC.open{display:flex;}\n#melolEC .ec-card{position:relative;background:#fff;color:#111;max-width:420px;width:100%;border-radius:18px;padding:26px 22px 22px;font-family:Inter,Arial,sans-serif;box-shadow:0 18px 60px rgba(0,0,0,.35);text-align:center;}\n#melolEC .ec-close{position:absolute;top:10px;right:14px;background:none;border:none;font-size:28px;line-height:1;color:#aaa;cursor:pointer;}\n#melolEC .ec-emoji{font-size:34px;margin:0 0 6px;}\n#melolEC .ec-h{font-size:21px;font-weight:800;margin:0 0 6px;letter-spacing:.2px;}\n#melolEC .ec-sub{font-size:14px;color:#555;margin:0 0 16px;line-height:1.45;}\n#melolEC .ec-form{display:flex;flex-direction:column;gap:10px;}\n#melolEC .ec-input{width:100%;box-sizing:border-box;padding:14px 15px;border:1.5px solid #d4d4d4;border-radius:12px;font:600 16px Inter,Arial,sans-serif;outline:none;}\n#melolEC .ec-input:focus{border-color:#0a66ff;}\n#melolEC .ec-hp{position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;}\n#melolEC .ec-submit{width:100%;box-sizing:border-box;padding:14px 15px;background:#0a66ff;color:#fff;border:none;border-radius:12px;font:800 16px Inter,Arial,sans-serif;cursor:pointer;}\n#melolEC .ec-submit:active{transform:scale(.99);}\n#melolEC .ec-fine{font-size:11px;color:#999;margin:11px 0 0;line-height:1.4;}\n#melolEC .ec-nope{display:block;background:none;border:none;color:#aaa;font-size:12px;margin:9px auto 0;cursor:pointer;text-decoration:underline;}\n#melolEC .ec-err{color:#c0392b;font-size:12.5px;font-weight:600;margin:8px 0 0;display:none;}\n/* success state */\n#melolEC .ec-won{display:none;}\n#melolEC.won .ec-form,#melolEC.won .ec-sub,#melolEC.won .ec-fine,#melolEC.won .ec-nope{display:none;}\n#melolEC.won .ec-won{display:block;}\n#melolEC .ec-code{display:inline-block;font:900 22px 'Montserrat',Arial,sans-serif;letter-spacing:2px;color:#111;background:#f4f4f8;border:2px dashed #0a66ff;border-radius:12px;padding:11px 18px;margin:8px 0 14px;cursor:pointer;}\n#melolEC .ec-shop{display:block;width:100%;box-sizing:border-box;padding:14px;background:#16a34a;color:#fff;text-decoration:none;border:none;border-radius:12px;font:800 16px Inter,Arial,sans-serif;cursor:pointer;}\n/* tiny inline nudge chip that rides under the share suite */\n#melolECchip{display:block;width:calc(100% - 4px);margin:10px auto 0;padding:11px 14px;background:#0a66ff;color:#fff;border:none;border-radius:11px;font:700 13.5px Inter,Arial,sans-serif;cursor:pointer;text-align:center;}\n\n/* in-app webview escape hatch — dismissible bottom bar */\n#melolWVBanner{position:fixed;left:0;right:0;bottom:0;z-index:100060;background:#111;color:#fff;\n  font:600 13px/1.4 -apple-system,Inter,Arial,sans-serif;padding:11px 12px calc(11px + env(safe-area-inset-bottom));\n  box-shadow:0 -8px 30px rgba(0,0,0,.42);}\n#melolWVBanner .wv-row{display:flex;align-items:center;gap:9px;max-width:640px;margin:0 auto;}\n#melolWVBanner .wv-txt{flex:1;text-align:left;font-size:12.5px;line-height:1.35;color:#fff;}\n#melolWVBanner .wv-txt b{color:#fff;}\n#melolWVBanner .wv-open{flex-shrink:0;padding:9px 13px;background:#0a66ff;color:#fff;border:none;border-radius:10px;font:800 12.5px Inter,Arial,sans-serif;cursor:pointer;}\n#melolWVBanner .wv-x{flex-shrink:0;background:none;border:none;color:#aaa;font-size:22px;line-height:1;padding:0 4px;cursor:pointer;}\n#melolWVBanner .wv-sub{display:block;text-align:center;font-size:10.5px;color:#aaa;margin-top:6px;}\n\n";
  try{ var st=document.createElement('style'); st.type='text/css'; st.appendChild(document.createTextNode(css));
       (document.head||document.documentElement).appendChild(st); }catch(e){}
})();

/* ---------- (1) Save-Image in-app fix (V2) ---------- */
(function(){
  if(window.__melolSaveImgFix) return; window.__melolSaveImgFix=1;

  var UA = navigator.userAgent || '';
  var INAPP = /FBAN|FBAV|FB_IAB|FBIOS|Messenger|Instagram|Line\/|Snapchat|Pinterest|Twitter|TikTok|musical_ly|Bytedance|MicroMessenger|GSA\//i.test(UA);
  var iOSWebview     = /iPhone|iPad|iPod/i.test(UA) && !/Safari/i.test(UA) && !/CriOS|FxiOS/i.test(UA);
  var androidWebview = /Android/i.test(UA) && /; wv\)|Version\/\d/i.test(UA) && !/Chrome\/\d+\.\d+\.\d+\.\d+ Mobile Safari/i.test(UA);
  var USE_FIX = INAPP || iOSWebview || androidWebview;
  if(!USE_FIX) return;   // real browser → leave native download alone
  var IS_ANDROID = /Android/i.test(UA);

  var _lastFile=null;

  function dataUrlToFile(dataUrl, name){
    try{
      var parts=dataUrl.split(','); var mime=(parts[0].match(/data:([^;]+)/)||[])[1]||'image/png';
      var bin=atob(parts[1]); var len=bin.length; var arr=new Uint8Array(len);
      for(var i=0;i<len;i++) arr[i]=bin.charCodeAt(i);
      return new File([arr], name||'me-lol-shirt.png', {type:mime});
    }catch(e){ return null; }
  }

  // Escape the in-app webview into the real browser, where Save Image works normally.
  function openInBrowser(){
    var url=location.href;
    if(IS_ANDROID){
      try{
        var noProto=url.replace(/^https?:\/\//,'');
        // Android intent → open THIS page in Chrome. Falls back harmlessly if Chrome is absent.
        location.href='intent://'+noProto+'#Intent;scheme=https;package=com.android.chrome;end';
        return;
      }catch(e){}
    }
    try{ window.open(url,'_blank'); }catch(e){}
  }

  function setHint(t){ var h=document.querySelector('#melolSaveImg .msi-hint'); if(h) h.textContent=t; }
  function showBrowserBtn(){ var b=document.querySelector('#melolSaveImg .msi-browser'); if(b) b.style.display='inline-block'; }

  function fallback(){
    setHint(IS_ANDROID
      ? 'Facebook can’t save photos in its own browser. Tap “Open in browser” below, then tap 📸 Save Image again — it’ll save.'
      : 'Facebook can’t save photos in its own browser. Tap ⋯ / aA at the top corner → “Open in Browser”, then tap 📸 Save Image again.');
    showBrowserBtn();
  }

  function doSave(){
    // Try the native share sheet directly (don't trust canShare — it under-reports on FB/IG).
    if(navigator.share && _lastFile){
      var payload={ files:[_lastFile], title:'My Me.LOL shirt', text:'me.lol' };
      var attempt;
      try{ attempt = navigator.share(payload); }
      catch(e){ attempt = null; }
      if(attempt && attempt.then){
        attempt.then(function(){ /* shared/saved */ }, function(err){
          if(err && err.name==='AbortError') return;   // user closed the sheet — fine
          fallback();
        });
        return;
      }
    }
    fallback();
  }

  function buildModal(){
    var ov=document.getElementById('melolSaveImg');
    if(ov) return ov;
    ov=document.createElement('div'); ov.id='melolSaveImg';
    ov.innerHTML=''
      +'<p class="msi-hint"></p>'
      +'<img class="msi-pic" alt="Your shirt design">'
      +'<button type="button" class="msi-share">📷 Save to photos</button>'
      +'<button type="button" class="msi-browser">Open in browser to save</button>'
      +'<button type="button" class="msi-close">Done</button>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function(e){ if(e.target===ov) hide(); });
    ov.querySelector('.msi-close').addEventListener('click', hide);
    ov.querySelector('.msi-share').addEventListener('click', doSave);
    ov.querySelector('.msi-browser').addEventListener('click', openInBrowser);
    return ov;
  }
  function hide(){ var ov=document.getElementById('melolSaveImg'); if(ov) ov.classList.remove('open'); }

  function show(dataUrl){
    var ov=buildModal();
    ov.querySelector('.msi-pic').src=dataUrl;
    _lastFile=dataUrlToFile(dataUrl, 'me-lol-shirt.png');
    setHint('Save your shirt 👇');
    // On Android FB the share sheet often can't save — surface the browser escape up front.
    var bb=ov.querySelector('.msi-browser'); bb.style.display = IS_ANDROID ? 'inline-block' : 'none';
    ov.classList.add('open');
  }

  // Hook the theme's <a download>.click(): in a webview that click navigates to the data: URL and
  // fails. Swallow it for image downloads only and show the save modal instead. Everything else
  // (normal links, Copy-Link anchors, non-image downloads) passes straight through untouched.
  var _click = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function(){
    try{
      var href = this.getAttribute('href') || this.href || '';
      if(this.hasAttribute('download') && /^data:image\//i.test(href)){
        show(href);
        return;
      }
    }catch(e){}
    return _click.apply(this, arguments);
  };
})();

/* ---------- (2) email capture popup ---------- */
(function(){
  if(window.__melolEmailCapture) return;

  /* ============================ CONFIG ============================ */
  var CFG = {
    CODE:        'LOL10',          // the discount code revealed on capture (evergreen)
    PCT:         '10%',            // shown in the copy
    PRODUCT:     '/products/put-it-on-a-free-shirt',
    FIRST_VISIT_DELAY_MS: 5000,    // wait this long before the first-visit offer (let them play first)

    // Cloudflare Worker capture endpoint (server-side customer create + tags + Beehiiv). PRIMARY save.
    SUBSCRIBE_URL: 'https://lively-fog-cef0.louddrums.workers.dev/subscribe',

    // copy per trigger source:
    COPY: {
      save:   { emoji:'📸', h:'Nice shirt. Want '+'10%'+' off it?',   sub:'Drop your email — we’ll send your code and keep your design safe.' },
      copy:   { emoji:'🔗', h:'Link copied. Want '+'10%'+' off?',      sub:'Get your code emailed over before you share it around.' },
      first:  { emoji:'👋', h:'Here’s '+'10%'+' off, on us.',      sub:'Email = your code + first dibs when another shirt drops. That’s it.' },
      notify: { emoji:'🔔', h:'We’ll ping you the second it drops.', sub:'Enter your email and we’ll email you the moment it goes live.' },
            cart:   { emoji:'🛒', h:'Want '+'10%'+' off before checkout?', sub:'Drop your email — we’ll send your code and hold your cart.' }
    }
  };
  /* =============================================================== */

  var LS_DONE='melol_ec_done', LS_SEEN='melol_ec_seen';
  function done(){ try{ return localStorage.getItem(LS_DONE)==='1'; }catch(e){ return false; } }
  function markDone(){ try{ localStorage.setItem(LS_DONE,'1'); }catch(e){} }
  function curDomain(){
    try{ var p=new URLSearchParams(location.search).get('domain'); return (p||sessionStorage.getItem('melol_domain')||'').toLowerCase(); }
    catch(e){ return ''; }
  }

  /* ============ signup enrichment (cart / style / device / referrer / viewed) ============ */
  // entry referrer + utm — captured ONCE per session (external referrer only)
  function captureEntry(){
    try{
      if(sessionStorage.getItem('melol_entry')) return;
      var p=new URLSearchParams(location.search);
      var ref=(document.referrer||'');
      try{ if(ref && new URL(ref).host.indexOf('me.lol')>-1) ref=''; }catch(_){}   // ignore same-site hops
      sessionStorage.setItem('melol_entry', JSON.stringify({
        ref: ref.slice(0,300),
        utm_source:p.get('utm_source')||'', utm_medium:p.get('utm_medium')||'', utm_campaign:p.get('utm_campaign')||''
      }));
    }catch(e){}
  }
  function getEntry(){ try{ return JSON.parse(sessionStorage.getItem('melol_entry')||'{}'); }catch(e){ return {}; } }
  captureEntry();

  function getDevice(){
    var ua=navigator.userAgent||'';
    var os=/iPhone|iPad|iPod/i.test(ua)?'ios':(/Android/i.test(ua)?'android':(/Windows/i.test(ua)?'windows':(/Mac OS X|Macintosh/i.test(ua)?'mac':'other')));
    var type=/Mobi|Android|iPhone|iPad|iPod/i.test(ua)?'mobile':'desktop';
    return { type:type, os:os };
  }
  function getStyle(){
    try{
      var el=document.querySelector('input[name="properties[Finger style]"]');
      var v=el&&el.value?el.value:'';
      if(!v){ var r=document.querySelector('input[type="radio"][name*="Finger" i]:checked, input[type="radio"][name*="add-on" i]:checked'); if(r) v=r.value||''; }
      return String(v||'').trim().slice(0,40);
    }catch(e){ return ''; }
  }
  function getViewed(){
    try{ var a=JSON.parse(localStorage.getItem('melol_visited')||'[]'); return Array.isArray(a)?a.slice(0,6):[]; }catch(e){ return []; }
  }
  function getCart(cb){
    try{
      fetch('/cart.js',{headers:{Accept:'application/json'}, credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(c){
          var items=((c&&c.items)||[]).map(function(it){
            var p=it.properties||{};
            return { domain:String(p['Domain name on shirt']||'').toLowerCase().trim(), style:String(p['Finger style']||'').trim(), qty:it.quantity||1 };
          }).filter(function(it){ return it.domain; });
          cb({ count:(c&&c.item_count)||0, value:((c&&c.total_price)||0)/100, items:items });
        })
        .catch(function(){ cb({ count:0, value:0, items:[] }); });
    }catch(e){ cb({ count:0, value:0, items:[] }); }
  }

  // ---- clipboard that works in FB/IG/Messenger webviews (they often block navigator.clipboard) ----
  function legacyCopy(txt){
    try{
      var ta=document.createElement('textarea'); ta.value=txt; ta.setAttribute('readonly','');
      ta.style.cssText='position:absolute;left:-9999px;top:0;';
      document.body.appendChild(ta); ta.select(); try{ ta.setSelectionRange(0,txt.length); }catch(e){}
      document.execCommand('copy'); document.body.removeChild(ta);
    }catch(e){}
  }
  function copyCode(txt){
    try{
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(txt).catch(function(){ legacyCopy(txt); });
      } else { legacyCopy(txt); }
    }catch(e){ legacyCopy(txt); }
  }
  // apply the discount without a full navigation (the /discount redirect stalls inside webviews)
  function applyDiscount(){ try{ fetch('/discount/'+CFG.CODE, { redirect:'follow', credentials:'same-origin' }).catch(function(){}); }catch(e){} }

  function build(){
    if(document.getElementById('melolEC')) return;
    var ov=document.createElement('div'); ov.id='melolEC';
    ov.innerHTML=''
      +'<div class="ec-card">'
      +'  <button class="ec-close" aria-label="Close">&times;</button>'
      +'  <div class="ec-live">'
      +'    <div class="ec-emoji"></div>'
      +'    <h3 class="ec-h"></h3>'
      +'    <p class="ec-sub"></p>'
      +'    <form class="ec-form" novalidate>'
      +'      <input class="ec-hp" type="text" name="hp" tabindex="-1" autocomplete="off" aria-hidden="true">'
      +'      <input class="ec-input" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com" required>'
      +'      <button class="ec-submit" type="submit">Email me the code</button>'
      +'    </form>'
      +'    <div class="ec-err"></div>'
      +'    <p class="ec-fine">One-tap unsubscribe anytime. No spam, just shirts.</p>'
      +'    <button class="ec-nope" type="button">No thanks</button>'
      +'  </div>'
      +'  <div class="ec-won">'
      +'    <div class="ec-emoji">🎉</div>'
      +'    <h3 class="ec-h">You’re in — code copied:</h3>'
      +'    <span class="ec-code" title="Tap to copy"></span>'
      +'    <button type="button" class="ec-shop">Apply '+CFG.PCT+' &amp; keep shopping</button>'
      +'  </div>'
      +'</div>';
    document.body.appendChild(ov);
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
    ov.querySelector('.ec-close').addEventListener('click',close);
    ov.querySelector('.ec-nope').addEventListener('click',close);
    ov.querySelector('.ec-form').addEventListener('submit',submit);
    ov.querySelector('.ec-code').addEventListener('click',function(){
      var t=this; copyCode(CFG.CODE); t.textContent='✓ Copied!'; setTimeout(function(){ t.textContent=CFG.CODE; },1400);
    });
    // GREEN BUTTON: apply discount + close. No navigation → can't freeze the webview.
    ov.querySelector('.ec-shop').addEventListener('click',function(e){
      e.preventDefault(); copyCode(CFG.CODE); applyDiscount(); close();
    });
    return ov;
  }

  var _source='first', _domain='';
  function open(source, domOverride){
    if(done()) return;                         // already captured — never nag
    _source=source||'first'; _domain=(String(domOverride||'').toLowerCase())||curDomain();
    var ov=build();
    var c=CFG.COPY[_source]||CFG.COPY.first;
    ov.classList.remove('won');
    ov.querySelector('.ec-emoji').textContent=c.emoji;
    ov.querySelector('.ec-h').textContent=c.h;
    ov.querySelector('.ec-sub').textContent=c.sub;
    ov.querySelector('.ec-err').style.display='none';
    ov.classList.add('open');
    setTimeout(function(){ var i=ov.querySelector('.ec-input'); if(i){ try{ i.focus(); }catch(e){} } },120);
  }
  function close(){ var ov=document.getElementById('melolEC'); if(ov) ov.classList.remove('open'); }
  window.__melolEmailCapture=open;

  function submit(e){
    e.preventDefault();
    var ov=document.getElementById('melolEC');
    var input=ov.querySelector('.ec-input'), err=ov.querySelector('.ec-err'), btn=ov.querySelector('.ec-submit');
    var hp=(ov.querySelector('.ec-hp')||{}).value || '';
    var email=(input.value||'').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ err.textContent='That email looks off — mind checking it?'; err.style.display='block'; return; }
    btn.disabled=true; btn.textContent='Sending…'; err.style.display='none';

    function fail(){
      btn.disabled=false; btn.textContent='Email me the code';
      err.textContent='Hmm — that didn’t go through. Mind trying again?';
      err.style.display='block';
    }
    function win(){
      markDone();
      try{
        if(typeof gtag!=='undefined') gtag('event','email_capture',{ source:_source, domain:_domain });
        if(typeof clarity!=='undefined') clarity('set','email_captured',_source);
      }catch(_){}
      var codeEl=ov.querySelector('.ec-code'); codeEl.textContent=CFG.CODE;
      copyCode(CFG.CODE);                        // auto-copy the moment the reward shows
      ov.classList.add('won');
    }

    if (CFG.SUBSCRIBE_URL) {
      // PRIMARY: server-side capture via the Worker (captcha-free, tags stick, mirrors to Beehiiv).
      // Grab the enrichment snapshot (cart + style + device + referrer + viewed) then post it all.
      getCart(function(cart){
        var payload={ email:email, source:_source, domain:_domain, hp:hp,
          style:getStyle(), cart:cart, viewed:getViewed(), device:getDevice(), entry:getEntry() };
        fetch(CFG.SUBSCRIBE_URL, { method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify(payload) })
          .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){ return { ok:r.ok, j:j }; }); })
          .then(function(res){ if(res.ok && res.j && res.j.ok) win(); else fail(); })
          .catch(fail);
      });
    } else {
      // LEGACY fallback: Shopify /contact (only works if hCaptcha is OFF)
      var body=new URLSearchParams();
      body.append('form_type','customer'); body.append('utf8','✓'); body.append('contact[email]', email);
      fetch('/contact', { method:'POST', headers:{'Content-Type':'application/x-www-form-urlencoded'}, body:body.toString() })
        .then(function(r){ if(r && (r.ok || r.redirected || r.status < 400)) win(); else fail(); })
        .catch(fail);
    }
  }

  /* ---------- TRIGGER 1: Save Image / Copy Link (peak intent) ---------- */
  document.addEventListener('click', function(e){
    if(done()) return;
    var b=e.target && e.target.closest && e.target.closest('button,a');
    if(!b) return;
    if(b.closest('#melolEC')) return;
    var t=((b.textContent||'')+' '+(b.getAttribute&&(b.getAttribute('aria-label')||''))).toLowerCase();
    if(/save image/.test(t)){ setTimeout(function(){ open('save'); }, 900); }
    else if(/copy link/.test(t)){ setTimeout(function(){ open('copy'); }, 500); }
  }, true);

    /* ---------- TRIGGER 4: ADD TO CART — the moment that makes someone recoverable ----------
     97.4% of captures happen before the visitor has a cart, which is why abandoned-cart
     email only has ~14 people/month to send to. Matched on name="add" or literal
     "add to cart"/"add to bag" — deliberately NOT a bare /add/ test, which would fire on
     the 'Add The "Finger"' VARIANT label. Click delegation on purpose: V600 already
     monkey-patches window.fetch and XMLHttpRequest and is the leading suspect for the
     Jul 5 checkout-event break. Do not add a second patch. */
  document.addEventListener('click', function(e){
    if(done()) return;
    var b=e.target && e.target.closest && e.target.closest('button,input[type=submit],a');
    if(!b || b.closest('#melolEC')) return;
    var nm=((b.getAttribute && b.getAttribute('name'))||'').toLowerCase();
    var tx=((b.textContent||'')+' '+((b.getAttribute && b.getAttribute('aria-label'))||'')).toLowerCase();
    if(nm!=='add' && !/add to cart|add to bag/.test(tx)) return;
    setTimeout(function(){ open('cart'); }, 2200);   // let the cart drawer render first
  }, true);

  /* ---------- TRIGGER 2: Notify-Me on drops ---------- */
  // pull the SPECIFIC drop domain the user tapped (card/gate/banner), so notify signups are
  // tagged dom-<that-drop>, not just the page they were on. Falls back to the page domain.
  var DROP_TLD=/\b([a-z0-9-]+\.(?:lol|wtf|no|so|si|you|us|me|one|mom|dad|fyi|sh|to|news))\b/i;
  function dropDomainFrom(el){
    try{
      var node=el;
      for(var i=0;i<4 && node;i++){
        var d=node.getAttribute&&(node.getAttribute('data-melol-domain')||node.getAttribute('data-domain'));
        if(d) return d.toLowerCase();
        var m=(node.textContent||'').match(DROP_TLD);
        if(m) return m[1].toLowerCase();
        node=node.parentElement;
      }
    }catch(e){}
    return '';
  }
  document.addEventListener('click', function(e){
    var b=e.target && e.target.closest && e.target.closest('#melolDropNotify, #melolTopNotify, button, a, div');
    if(!b) return;
    if(b.closest('#melolEC')) return;
    var isNotify = b.id==='melolDropNotify' || b.id==='melolTopNotify' ||
                   /(^|\s)🔔|notify me/i.test((b.textContent||''));
    if(!isNotify) return;
    if(done()){ return; }
    e.preventDefault(); e.stopImmediatePropagation();
    open('notify', dropDomainFrom(b));
  }, true);

  /* ---------- TRIGGER 3: first-visit offer (once per visitor, after they've played) ---------- */
  function maybeFirstVisit(){
    if(done()) return;
    var seen=false; try{ seen=localStorage.getItem(LS_SEEN)==='1'; }catch(e){}
    if(seen) return;
    try{ localStorage.setItem(LS_SEEN,'1'); }catch(e){}
    setTimeout(function(){ if(!done()) open('first'); }, CFG.FIRST_VISIT_DELAY_MS);
  }
  if(location.pathname.indexOf('/products/')===0){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',maybeFirstVisit); else maybeFirstVisit();
  }

  /* ---------- Optional: a persistent nudge chip under the share suite ---------- */
  function placeChip(){
    if(done()){ var old=document.getElementById('melolECchip'); if(old) old.remove(); return; }
    if(document.getElementById('melolECchip')) return;
    var suite=document.getElementById('melolShareSuite'); if(!suite) return;
    var chip=document.createElement('button'); chip.id='melolECchip'; chip.type='button';
    chip.textContent='✉️ Get '+CFG.PCT+' off — email me my code';
    chip.addEventListener('click',function(){ open('save'); });
    suite.parentNode.insertBefore(chip, suite.nextSibling);
  }
  if(location.pathname.indexOf('/products/')===0){
    var _n=0, _iv=setInterval(function(){ _n++; placeChip(); if(_n>25||document.getElementById('melolECchip')) clearInterval(_iv); }, 400);
    try{ new MutationObserver(placeChip).observe(document.body,{childList:true,subtree:true}); }catch(e){}
  }
})();

/* ---------- (3) in-app-browser escape hatch ---------- */

/* ===== ME.LOL — in-app-browser escape hatch (proactive) =====
   Facebook / Messenger / Instagram in-app browsers run this theme's heavy JS poorly — pages can
   FREEZE on navigation (tap a link/card -> stuck) or come up blank. We can't fix Facebook's browser,
   so we route shoppers out of it: a dismissible one-tap "open in your real browser" bar for in-app
   visitors (once per session). If a product/cart page actually comes up blank, we force the bar back
   even if dismissed. Dormant on every normal browser. */
(function(){
  if(window.__melolWVHatch) return; window.__melolWVHatch=1;
  var UA=navigator.userAgent||'';
  var INAPP=/FBAN|FBAV|FB_IAB|FBIOS|Messenger|Instagram|Line\/|Snapchat|Pinterest|Twitter|TikTok|musical_ly|Bytedance|MicroMessenger|GSA\//i.test(UA);
  if(!INAPP) return;                                   // only ever touch in-app browsers
  var IS_ANDROID=/Android/i.test(UA);
  var supportsModules=('noModule' in HTMLScriptElement.prototype);
  var supportsCE=!!(window.customElements&&window.customElements.define);
  var themeCanRun=supportsModules&&supportsCE;
  var DKEY='melol_wv_dismissed';
  function dismissed(){ try{ return sessionStorage.getItem(DKEY)==='1'; }catch(e){ return false; } }
  function setDismissed(){ try{ sessionStorage.setItem(DKEY,'1'); }catch(e){} }

  function openBrowser(){
    var url=location.href;
    if(IS_ANDROID){ try{ location.href='intent://'+url.split('://').pop()+'#Intent;scheme=https;package=com.android.chrome;end'; return; }catch(e){} }
    try{ window.open(url,'_blank'); }catch(e){}
  }
  function build(force){
    if(document.getElementById('melolWVBanner')) return;
    if(!force && dismissed()) return;
    var b=document.createElement('div'); b.id='melolWVBanner';
    b.innerHTML=''
      +'<div class="wv-row">'
      +'<span class="wv-txt">Facebook’s browser can freeze on Me.LOL. Open it in your <b>real browser</b> for the full site.</span>'
      +'<button type="button" class="wv-open">Open in browser</button>'
      +'<button type="button" class="wv-x" aria-label="Dismiss">×</button>'
      +'</div>'
      +'<span class="wv-sub">or tap '+(IS_ANDROID?'⋮ (top-right)':'⋯ / ａA (top corner)')+' → “Open in browser”</span>';
    (document.body||document.documentElement).appendChild(b);
    b.querySelector('.wv-open').addEventListener('click',openBrowser);
    b.querySelector('.wv-x').addEventListener('click',function(){ setDismissed(); var el=document.getElementById('melolWVBanner'); if(el) el.remove(); });
  }
  function isDead(){
    if(!themeCanRun) return true;
    var p=location.pathname;
    if(p.indexOf('/products/')!==0 && p.indexOf('/cart')!==0) return false;
    var txt=((document.body&&document.body.innerText)||'').replace(/\s+/g,' ').trim();
    var content=document.querySelector('product-form-component,add-to-cart-component,button[name="add"],.cart-items__table-row,.cart__empty-text,.product-information,.product-form,.product__title,#melolShareSuite');
    if(!content && txt.length<400) return true;
    return false;
  }
  function boot(){
    if(!IS_ANDROID) return;                            // iOS in-app browsers run the theme fine — never nag them
    build(false);                                      // proactive nudge, once per session (Android only)
    setTimeout(function(){ if(isDead()) build(true); }, 1500);   // blank page -> force back
    setTimeout(function(){ if(isDead()) build(true); }, 4000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();


/* ---------- (4) endless Featured strip — lazy-load more shirts on scroll-to-end ---------- */
(function(){
  if(location.pathname.indexOf('/products/')!==0) return;
  if(window.__melolEndlessStrip) return; window.__melolEndlessStrip=true;
  window.__melolCES='2026-07-24e';

  var PRODUCT='/products/put-it-on-a-free-shirt';
  var SHIRT_IMG='https://cdn.shopify.com/s/files/1/0714/1697/1451/files/FinalFlatShirt.png';
  var CATALOG_URL='https://cdn.shopify.com/s/files/1/0714/1697/1451/files/catalog326.txt?v='+Math.floor(Date.now()/600000); // 10-min cache-bust: catalog edits go live without a code change
  var VALID=/\.(lol|wtf|no|so|si|you|us|me|one|mom|dad|fyi|sh|to|news)$/;
  var BATCH=15, NEAR=600;   // append 15 per trigger; fire when within 600px of the end

  // stable-per-session ordering (seed stored once) so the strip is IDENTICAL across page loads —
  // that's what makes "keep my place" work when tapping a shirt reloads the page.
  function fsSeed(){ var s=null; try{ s=sessionStorage.getItem('melol_fs_seed'); }catch(e){}
    if(!s){ s=String(Math.floor(Math.random()*2147483647)+1); try{ sessionStorage.setItem('melol_fs_seed',s); }catch(e){} }
    return (parseInt(s,10)||12345); }
  function mulberry32(a){ return function(){ a|=0; a=a+0x6D2B79F5|0; var t=Math.imul(a^a>>>15,1|a); t=t+Math.imul(t^t>>>7,61|t)^t; return ((t^t>>>14)>>>0)/4294967296; }; }
  function shuffleSeeded(arr){ var rnd=mulberry32(fsSeed()); for(var i=arr.length-1;i>0;i--){ var j=Math.floor(rnd()*(i+1)); var t=arr[i]; arr[i]=arr[j]; arr[j]=t; } return arr; }

  // catalog pool — fetched ONCE, lazily, only when the strip first needs more (nothing preloaded)
  var _pool=null, _loading=false, _waiters=[];
  function loadPool(cb){
    if(_pool){ cb(_pool); return; }
    _waiters.push(cb);
    if(_loading) return; _loading=true;
    fetch(CATALOG_URL,{cache:'no-store'}).then(function(r){ return r.text(); }).then(function(txt){
      var arr=txt.split(/[\s,]+/).map(function(s){ return (s||'').trim().toLowerCase(); })
                 .filter(function(d){ return d && /^[a-z0-9]/.test(d) && d.indexOf('.')>-1 && VALID.test(d); }); // '*'-prefixed = expired/hidden
      shuffleSeeded(arr);   // same order every page this session → restorable scroll position
      _pool=arr; _loading=false; var w=_waiters; _waiters=[]; w.forEach(function(f){ try{ f(_pool); }catch(e){} });
    }).catch(function(){ _loading=false; _waiters=[]; });
  }

  function curDomain(){ try{ var p=new URLSearchParams(location.search).get('domain'); return (p||sessionStorage.getItem('melol_domain')||'me.lol').toLowerCase(); }catch(e){ return 'me.lol'; } }

  // build a card identical to the theme's .fs-card (84x84, word+tld overlay)
  function makeCard(domain){
    var ld=domain.lastIndexOf('.');
    var w=(ld>=0?domain.slice(0,ld):domain).toUpperCase();
    var t=(ld>=0?domain.slice(ld):'').toUpperCase();
    if(t==='.WTF'||t==='.SO'||t==='.TO') t+='?';
    var fs=Math.min(17,Math.max(8,Math.round(84*0.22/Math.max(w.length*0.58,1))));
    var a=document.createElement('a');
    a.className='fs-card'; a.href=PRODUCT+'?domain='+encodeURIComponent(domain);
    a.setAttribute('data-melol-featured','1'); a.setAttribute('data-melol-more','1');
    a.innerHTML='<img class="fs-shirt" src="'+SHIRT_IMG+'" alt="" loading="lazy">'+
      '<span class="fs-ov"><span class="fs-w" style="font-size:'+fs+'px;">'+w+'</span>'+
      '<span class="fs-t" style="font-size:'+Math.max(7,Math.round(fs*0.5))+'px;">'+t+'</span></span>';
    return a;
  }
  // final card when the whole catalog is exhausted: turns "the end" into "make your own"
  function makeTypeYourOwn(){
    var a=document.createElement('a');
    a.className='fs-card'; a.href='#'; a.setAttribute('data-melol-more','end');
    a.style.cssText='display:flex;align-items:center;justify-content:center;text-align:center;background:#0a66ff;';
    a.innerHTML='<span style="color:#fff;font:800 12px/1.15 Inter,Arial,sans-serif;padding:6px;">✏️ Type<br>your own</span>';
    a.addEventListener('click',function(e){ e.preventDefault(); if(window.__melolOpenCatalogSearch) window.__melolOpenCatalogSearch(); });
    return a;
  }

  function seenSet(row){
    var s={}; s[curDomain()]=1; s['me.lol']=1;
    var els=row.querySelectorAll('a.fs-card');
    for(var i=0;i<els.length;i++){ var m=(els[i].getAttribute('href')||'').match(/domain=([^&]+)/); if(m){ try{ s[decodeURIComponent(m[1]).toLowerCase()]=1; }catch(e){} } }
    return s;
  }
  function fill(row){
    if(row.getAttribute('data-ces-capped')==='1' || row.__cesFilling) return;
    row.__cesFilling=true;
    loadPool(function(pool){
      try{
        var seen=seenSet(row), added=0, frag=document.createDocumentFragment();
        for(var i=0;i<pool.length && added<BATCH;i++){ var d=pool[i]; if(seen[d]) continue; seen[d]=1; frag.appendChild(makeCard(d)); added++; }
        if(added>0) row.appendChild(frag);
        else { row.appendChild(makeTypeYourOwn()); row.setAttribute('data-ces-capped','1'); }   // pool exhausted
      }catch(e){}
      row.__cesFilling=false;
    });
  }
  function nearEnd(row){ return row.scrollLeft + row.clientWidth >= row.scrollWidth - NEAR; }

  // ---- remember & restore the scroll spot across the page reload a card-tap causes ----
  var _restoring=false;
  function saveLeft(row){ if(_restoring) return; try{ sessionStorage.setItem('melol_fs_left', String(Math.round(row.scrollLeft))); }catch(e){} }
  function restore(row){
    if(row.__cesRestored) return; row.__cesRestored=true;
    var left=0; try{ left=parseInt(sessionStorage.getItem('melol_fs_left')||'0',10)||0; }catch(e){}
    if(left<=60) return;                              // nothing meaningful saved
    _restoring=true;
    loadPool(function(pool){
      var guard=0;
      while(row.scrollWidth < left + row.clientWidth && guard<80){   // append (in the stable order) until we can reach the saved spot
        var seen=seenSet(row), added=0, frag=document.createDocumentFragment();
        for(var i=0;i<pool.length && added<BATCH;i++){ var d=pool[i]; if(seen[d]) continue; seen[d]=1; frag.appendChild(makeCard(d)); added++; }
        if(!added){ break; } row.appendChild(frag); guard++;
      }
      row.scrollLeft=left;                             // land back where they were
      setTimeout(function(){ _restoring=false; }, 60);
    });
  }
  function attach(row){
    if(row.__cesAttached) return; row.__cesAttached=true;
    var t=null;
    row.addEventListener('scroll', function(){ if(t) return; t=setTimeout(function(){ t=null; saveLeft(row); if(nearEnd(row)) fill(row); }, 120); }, {passive:true});
    row.addEventListener('click', function(){ saveLeft(row); }, true);   // capture the spot the instant a card is tapped
    restore(row);                                     // jump back to where they left off, if we saved a spot
    // if the strip isn't wide enough to scroll, seed one batch so there's something to scroll into
    setTimeout(function(){ if(row.scrollWidth <= row.clientWidth+40) fill(row); }, 400);
  }
  // the theme rebuilds the strip periodically → re-attach whenever a fresh #melolFSrow appears
  function scan(){ var row=document.getElementById('melolFSrow'); if(row && !row.__cesAttached) attach(row); }
  setInterval(scan, 600);
  try{ new MutationObserver(scan).observe(document.body,{childList:true,subtree:true}); }catch(e){}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan); else scan();
})();

/* ---------- (5) retired-domain kill-switch — expired ('*'-marked) shirts can't be bought ---------- */
(function(){
  if(location.pathname.indexOf('/products/')!==0) return;
  if(window.__melolExpiredInit) return; window.__melolExpiredInit=1;

  var CATALOG_URL='https://cdn.shopify.com/s/files/1/0714/1697/1451/files/catalog326.txt?v='+Math.floor(Date.now()/600000);
  var EXPIRED=null;                                   // built from the '*'-marked catalog lines
  function norm(d){ return String(d||'').toLowerCase().replace(/[^a-z0-9.\-]/g,''); }
  // exposed so the theme's search can suppress "put it on a shirt anyway" for retired ones too
  window.__melolExpired=function(d){ if(!EXPIRED) return false; return !!EXPIRED[norm(d)]; };

  function curDomain(){ try{ var p=new URLSearchParams(location.search).get('domain'); return norm(p||sessionStorage.getItem('melol_domain')||''); }catch(e){ return ''; } }

  function load(cb){
    fetch(CATALOG_URL,{cache:'no-store'}).then(function(r){ return r.text(); }).then(function(txt){
      var set={}; txt.split('\n').forEach(function(l){ l=l.trim(); if(l.charAt(0)==='*'){ var d=norm(l.slice(1)); if(d) set[d]=1; } });
      EXPIRED=set; cb&&cb();
    }).catch(function(){ EXPIRED={}; });                // fail-open: if the catalog can't load, don't block anything
  }

  // hide every way to buy (form + submit + dynamic/shop-pay + sticky bar)
  var BUY_SEL='form[action*="/cart/add"], product-form-component, button[name="add"], .product-form__submit, .shopify-payment-button, shopify-accelerated-checkout, .shop-pay-wallet-button, sticky-add-to-cart, [id*="sticky-add" i]';
  function hideBuy(){ try{ document.querySelectorAll(BUY_SEL).forEach(function(el){ el.style.setProperty('display','none','important'); }); }catch(e){} }

  function showMsg(){
    if(document.getElementById('melolRetired')) return;
    var host=document.querySelector('form[action*="/cart/add"], product-form-component, .product-information, main .product, main');
    if(!host||!host.parentNode) return;
    var box=document.createElement('div'); box.id='melolRetired';
    box.style.cssText='margin:14px 0;padding:16px;background:#fff;border:2px solid #111;border-radius:14px;font-family:Inter,Arial,sans-serif;text-align:center;box-shadow:0 6px 22px rgba(0,0,0,.08);';
    box.innerHTML='<div style="font-size:26px;line-height:1;margin-bottom:6px;">😅</div>'+
      '<div style="font-weight:800;font-size:16px;color:#111;margin-bottom:4px;">This one’s retired</div>'+
      '<div style="font-size:13.5px;color:#555;line-height:1.45;margin-bottom:12px;">Its domain isn’t available anymore, so it’s off the shelf. Plenty of others though — grab one of those 👇</div>'+
      '<button type="button" id="melolRetiredBtn" style="padding:12px 18px;background:#0a66ff;color:#fff;border:none;border-radius:11px;font:800 14px Inter,Arial,sans-serif;cursor:pointer;">Browse shirts</button>';
    host.parentNode.insertBefore(box, host);
    var b=box.querySelector('#melolRetiredBtn');
    if(b) b.addEventListener('click',function(){
      if(window.__melolOpenCatalogSearch) window.__melolOpenCatalogSearch();
      else { var s=document.getElementById('melolFSrow'); if(s) s.scrollIntoView({behavior:'smooth',block:'center'}); }
    });
  }

  function start(){
    load(function(){
      var d=curDomain();
      if(!d || !EXPIRED[d]) return;                    // live domain → do nothing at all
      window.MELOL_GATED=true;                          // reuse the theme's own add-to-cart block
      hideBuy(); showMsg();
      // Horizon re-renders its buy custom-elements → keep them hidden + message present while retired
      setInterval(function(){ window.MELOL_GATED=true; hideBuy(); showMsg(); }, 700);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();